module.exports = __webpack_public_path__ + "assets/img/nature-time-bg-5.4f43b15b.png";